(function(konto) {
	konto.bl = {};
} (konto = window.konto));
